import React from 'react'
import OverviewTable from './OverviewTable'

export default function RegionOverviewTable() {
  return <OverviewTable module="REGION" />
}
